module.exports = __webpack_public_path__ + "static/image008-bed913c8cb3b8f5bda273fe574e4a499.jpg";